module.exports = __webpack_public_path__ + "officialStatic/img/detail-seven-bg.1e44dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-seven-bg.png
// module id = 84xO
// module chunks = 0